import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Select, { components } from "react-select";
import JoditEditor from "jodit-react";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { toast } from "react-toastify";
import Response_Processing from "../../../layout/Others/Response_Processing";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import { slugGenerator } from "../../../components/CommonMethod/CommonMethods";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { IoMdInformationCircle } from "react-icons/io";

const MultiValue = (props) => {
  const val = String(props.data.value);
  return (
    <div
      draggable
      onDragStart={(e) => {
        e.dataTransfer.setData("text/plain", val);
        e.dataTransfer.effectAllowed = "move";
      }}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
        e.preventDefault();
        const dragged = e.dataTransfer.getData("text/plain");
        if (dragged && dragged !== val) props.selectProps.onReorder(dragged, val);
      }}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      style={{ cursor: "grab" }}
    >
      <components.MultiValue {...props} />
    </div>
  );
};

function Audio_Playlist() {
  const headers = getItemToken('access_token');
  const { id } = useParams();
  const combinedRef = useRef([]);
  const navigate = useNavigate();
  const BaseUrl = process.env.REACT_APP_Baseurl;

  const [formData, setFormData] = useState({
    title: '',
    slug: '',
    description: '',
    selected_audios: [],
  });

  const [formDataError, setFormDataError] = useState({});
  const [coverImageFile, setCoverImageFile] = useState(null);
  const [audioOptions, setAudioOptions] = useState([]);
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithOutRefresh] = useState(false);

  const handleReorder = (draggedId, targetId) => {
    const list = [...formData.selected_audios].map(Number);
    const fromIdx = list.indexOf(Number(draggedId));
    const toIdx = list.indexOf(Number(targetId));
    if (fromIdx > -1 && toIdx > -1) {
      list.splice(toIdx, 0, list.splice(fromIdx, 1)[0]);
      setFormData(prev => ({ ...prev, selected_audios: list }));
    }
  };

  const setRef = (element, index) => {
    if (element) {
      combinedRef.current[index] = element;
    }
  };

  const handleFileChange = async (event) => {
    const { files, name } = event.target;
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    setFormDataError((prev) => ({ ...prev, [name]: "" }));
    if (files?.length > 0) {
      const newFile = files[0];
      if (!allowedTypes.includes(newFile?.type)) {
        setFormDataError((prev) => ({ ...prev, [name]: "Only JPG, JPEG, and PNG files are allowed." }));
        setCoverImageFile(null);
        return;
      }
      setCoverImageFile(newFile);
    }
  };

  const handleImageUpload = async (playlistId) => {
    try {
      if (!coverImageFile) return;
      const formDataAdd = new FormData();
      formDataAdd.append('id', playlistId);
      formDataAdd.append('image', coverImageFile);
      const response = await axios.post(`${BaseUrl}/admin/audio/playlist/image-upload`, formDataAdd, { headers });
      if (response?.data?.status === false) {
        toast.error(response?.data?.message);
      }
      setCoverImageFile(null);
    } catch (err) {
      console.error(err);
    }
  };

  const handleAdd = async () => {
    setShowOverlay(true);
    try {
      const formDataAdd = {
        title: formData?.title,
        slug: formData?.slug,
        description: formData?.description,
        selected_audios: formData?.selected_audios || [],
      };
      const response = await axios.post(`${BaseUrl}/admin/audio/playlist/store`, formDataAdd, { headers });
      const result = response?.data;
      if (result?.status) {
        if (coverImageFile) {
          await handleImageUpload(result?.id);
        }
        setShowOverlay(false);
        toast.success(result?.message);
        navigate("/audio-playlist");
      } else {
        setShowOverlay(false);
        toast.error(result?.message);
      }
    } catch (err) {
      setShowOverlay(false);
      toast.error(err?.response?.data?.message);
      console.error("error", err);
    }
  };

  const handleUpdate = async () => {
    setShowOverlay(true);
    try {
      const formDataAdd = {
        title: formData?.title,
        slug: formData?.slug,
        description: formData?.description,
        selected_audios: formData?.selected_audios || [],
      };
      const response = await axios.post(`${BaseUrl}/admin/audio/playlist/update/${id}`, formDataAdd, { headers });
      const result = response?.data;
      if (result?.status) {
        if (coverImageFile) {
          await handleImageUpload(id);
        }
        setShowOverlay(false);
        toast.success(result?.message);
        setWithOutRefresh(!withOutRefresh);
      } else {
        setShowOverlay(false);
        toast.error(result?.message);
      }
    } catch (err) {
      setShowOverlay(false);
      toast.error(err?.response?.data?.message);
      console.error("error", err);
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormDataError((prev) => ({ ...prev, [name]: '' }));
  };

  const handleDescriptionChange = (newContent) => {
    setFormData((prev) => ({ ...prev, description: newContent }));
  };

  const handleSelectedAudios = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      selected_audios: (selectedOptions || []).map((option) => option.value),
    }));
    setFormDataError((prev) => ({ ...prev, selected_audios: '' }));
  };

  const handleInputKeyDowntitle = (event) => {
    if (event.key === "Enter" || event.key === "Tab") {
      if (formData?.slug) return;
      generateSlug(formData?.title);
    }
  };

  const handleBlurtitle = () => {
    if (formData?.slug) return;
    generateSlug(formData?.title);
  };

  const generateSlug = async (title) => {
    const slug = await slugGenerator(title);
    setFormData((prev) => ({ ...prev, slug }));
  };

  const fetchAudioOptions = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/admin/audio/index`, { headers, params: { limit: 1000, page: 1 } });
      const list = response?.data?.data || [];
      setAudioOptions(
        list
          .filter((audio) => audio?.current_status === "PUBLISHED")
          .map((audio) => ({ value: audio?.id, label: audio?.title }))
      );
    } catch (error) {
      console.error("Error fetching audios:", error);
    }
  };

  const fetchEditData = () => {
    axios.get(`${BaseUrl}/admin/audio/playlist/edit/${id}`, { headers })
      .then((response) => {
        const result = response?.data?.data;
        setFormData({
          ...result,
          selected_audios: Array.isArray(result?.selected_audios) ? result.selected_audios : [],
        });
      })
      .catch((error) => console.log(error));
  };

  const handleBlurTitleEdit = () => {
    generateSlug(formData?.slug);
  };

  const formValidation = () => {
    let formIsValid = true;
    if (!formData?.title) {
      setFormDataError((prev) => ({ ...prev, title: "Title cannot be empty." }));
      combinedRef.current['title']?.focus();
      formIsValid = false;
    }
    if (!formData?.slug) {
      setFormDataError((prev) => ({ ...prev, slug: "Slug cannot be empty." }));
      combinedRef.current['slug']?.focus();
      formIsValid = false;
    }
    if (!formData?.selected_audios || formData?.selected_audios?.length === 0) {
      setFormDataError((prev) => ({ ...prev, selected_audios: "Please select at least one audio track." }));
      formIsValid = false;
    }
    return formIsValid;
  };

  const handleStore = () => {
    if (formValidation()) {
      if (!id) handleAdd();
      else handleUpdate();
    }
  };

  const handleClearSelectFile = () => {
    setCoverImageFile(null);
  };

  useEffect(() => {
    fetchAudioOptions();
  }, []);

  useEffect(() => {
    if (id) fetchEditData();
  }, [withOutRefresh]);

  const selectedAudioValues = (formData?.selected_audios || [])
    .map((aid) => (audioOptions || []).find((option) => Number(option.value) === Number(aid)))
    .filter(Boolean);

  return (
    <div className="pb-5">
      {showOverlay && (<Response_Processing></Response_Processing>)}
      {<AdminBackNavigation path={"/audio-playlist"} text="Back" />}
      <AdminSaveHeader buttonId="audio-playlist-submit-up" heading={!id ? "Add Audio Playlist" : "Edit Audio Playlist"} saveText={!id ? "Add Playlist" : "Update Playlist"} saveMethod={handleStore} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageLabel text={"Playlist Name"} className="mandatorySimple" />
            <AdminCustomInput id="audio-playlist-title" type="text" name="title" value={formData?.title} onChange={handleInput} placeHolder={"Title"} ref={(el) => (combinedRef.current.title = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.title} />
            <MessageLabel text={"Slug"} className="mandatorySimple" />
            <AdminCustomInput id="audio-playlist-slug" type="text" name="slug" value={formData?.slug} ref={(el) => (combinedRef.current.slug = el)} onChange={handleInput} placeHolder={"Slug"} onBlur={handleBlurTitleEdit} error={formDataError?.slug} />
            <MessageLabel text={"Description"} />
            <JoditEditor
              className="video-details mb-3"
              value={formData?.description || ""}
              onChange={handleDescriptionChange}
              ref={(el) => (combinedRef.current.description = el)}
            />
          </Wrapper>
          <Wrapper>
            <MessageHeading text={"Audio Playlist"} />
            <MessageLabel text={"Audio Tracks"} className="mandatorySimple" />
            <MessageSubHeading text={"Search and select the audio tracks for this playlist"} />
            <Select
              id="audio-playlist-selected-audios"
              isMulti
              name="selected_audios"
              options={audioOptions}
              value={selectedAudioValues}
              onChange={handleSelectedAudios}
              ref={(el) => (combinedRef.current.selected_audios = el)}
              classNamePrefix="select"
              placeholder="Select audio tracks"
              className="custom-select-multi custom-placeholder theme-text-color mb-2"
              components={{ MultiValue }}
              onReorder={handleReorder}
            />
            {formDataError?.selected_audios && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.selected_audios}`} classname='errorred d-block' /></div>)}
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={"Thumbnail Image"} />
            <MessageLabel text={"Image"} />
            <MessageSubHeading text={"Select the playlist cover image"} />
            <AdminImageUploadZone
              onChange={handleFileChange}
              selectedFile={coverImageFile}
              uploadedImage={formData?.image}
              onDelete={handleClearSelectFile}
              fileInputRef={setRef}
              name="image"
              id={id}
              idAttribute="audio-playlist-image"
              ref={(el) => (combinedRef.current.image = el)}
              error={formDataError?.image}
            />
          </Wrapper>
        </RightWrapper>
        <AdminCustomButton id="audio-playlist-submit-down" className='px-3 py-1 m-0 ms-auto' saveMethod={handleStore} saveText={!id ? "Add Playlist" : "Update Playlist"} />
      </FormContainer>
    </div>
  );
}

export default Audio_Playlist;
